import { render, staticRenderFns } from "./NonVoting.vue?vue&type=template&id=04784b20"
import script from "./NonVoting.vue?vue&type=script&lang=js"
export * from "./NonVoting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports